import { useCallback } from 'react';
import type { MumulLiveProfileStatus } from 'shared/src/api';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

type CheckExp1789TargetLogParams = {
  goodsSno: number;
  profileSno: number;
  status: MumulLiveProfileStatus;
};

/**
 * 상품상세 무물라이브 실험(EXP1789) 대상 트래킹.
 * 대조군(A)·실험군(B) 공통으로 노출되는 집계용 여백 노출 시 상품당 1회 발화한다.
 */
export const useLogCheckExp1789Target = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  return useCallback(
    ({ goodsSno, profileSno, status }: CheckExp1789TargetLogParams) => {
      logGoodsAnalytics({
        name: 'CHECK_EXP_1789_TARGET',
        analytics: {
          GOODS_SNO: goodsSno.toString(),
          PROFILE_SNO: profileSno.toString(),
          PROFILE_STATUS: status,
        },
      });
    },
    [logGoodsAnalytics],
  );
};
